export const getDashboardLink = function (company, accountType) {
  let claimGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (company.dashboard_type === 'business_unit_intensity_breakdown' && claimGroup) {
    return "/".concat(accountType, "/claim_groups/").concat(claimGroup.id, "/regular_realtime_dashboard/").concat(company.id);
  }
  if (claimGroup) {
    return "/".concat(accountType, "/claim_groups/").concat(claimGroup.id, "/dashboard/").concat(company.id);
  }
  return company.dashboard_type === 'business_unit_intensity_breakdown' ? "/".concat(accountType, "/regular_realtime_dashboard/").concat(company.id) : "/".concat(accountType, "/dashboard/").concat(company.id);
};